// FBAN/FBAV/FB_IAB: Facebook/Messenger, Instagram, Barcelona: Threads, Line/, Zalo,
// BytedanceWebview/musical_ly: TikTok, MicroMessenger: WeChat, wv: Android WebView chung.
const IAB_REGEX =
  /FBAN|FBAV|FB_IAB|MessengerLite|Instagram|Barcelona|Threads|Line\/|Zalo|BytedanceWebview|musical_ly|TikTok|Telegram|MicroMessenger|WeChat|wv/i;

export const OPEN_IN_APP_BROWSER_WARNING_EVENT = "boide:open-in-app-browser-warning";

function isStandalonePwa() {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(display-mode: standalone)").matches
  );
}

export function isInAppBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return IAB_REGEX.test(ua) && !isStandalonePwa();
}

export function openInAppBrowserWarning() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(OPEN_IN_APP_BROWSER_WARNING_EVENT));
}
